// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3iiuG","inner":"Form_inner__1thfU","range":"Form_range__1xbM4","name":"Form_name__2oUKJ","actions":"Form_actions__YmfbW"};